// Used to calculate the minimum price for an album.
export const MINIMUM_PRICE_PER_RELEASE_TRACK = 0.25;
// Overall minimum for an album.
export const MINIMUM_PRICE_PER_ALBUM = 1.0;
// Overall minimum for a track.
export const MINIMUM_UNIT_PRICE = 0.69;
